module.exports = "/images/job-transfer-background.png?1f89faf1a87a1506e9cd43c2487951cc";